module.exports = __webpack_public_path__ + "static/media/A-Quick-Guide-To-Getting-The-Most-Value-For-Your-Totalled-Car-Instantly.a86e5c92.jpg";